import { CSSProperties, useEffect, useState } from "react";
import classes from "./ShareModal.module.css";

import {
  FacebookShareButton,
  TwitterShareButton,
  LinkedinShareButton,
  WhatsappShareButton,
  WhatsappIcon,
  FacebookIcon,
  FacebookMessengerIcon,
  TwitterIcon,
  LinkedinIcon,
  PinterestShareButton,
  PinterestIcon,
} from "react-share";
import { CloseIcon } from "@mantine/core";
import { InstagramFillIcon } from "../Icons";
import { useAppSelector } from "@/store/hooks";

interface Props {
  className?: string;
  style?: CSSProperties;

  shareUrl: string;
  description?: string;
  hashtag?: string[];
  image?: string;

  onClose?: () => void;
}

const ShareModal = ({
  className,
  style,

  shareUrl,
  description,
  hashtag,
  onClose,
  image,
}: Props) => {
  const classNames = [classes.ShareModal, className];
  const messengerUrl = `https://m.me/GadgetnGear?text=${encodeURIComponent(
    `${description || "Check this out:"} ${shareUrl}`
  )}`;
  const instagramUrl =
    useAppSelector((state) => state.global.socialLinksWidget?.instagram) ||
    "https://www.instagram.com/";

  const [isCopied, setIsCopied] = useState(false);

  const copyShareUrl = () => {
    navigator.clipboard.writeText(shareUrl);
    setIsCopied(true);
  };

  const openShareLink = (url: string) => {
    window.open(url, "_blank", "noopener,noreferrer");
  };

  // const shareViaInstagram = () => {
  //   openShareLink(instagramUrl);
  // };

const shareViaInstagram = async () => {
  await navigator.clipboard.writeText(shareUrl);

  const appUrl = "instagram://app";
  const webUrl = "https://www.instagram.com/gadgetngear/";

  // Try app open
  const timeout = setTimeout(() => {
    window.open(webUrl, "_blank", "noopener,noreferrer");
  }, 1500);

  // Hidden iframe trick
  const iframe = document.createElement("iframe");
  iframe.style.display = "none";
  iframe.src = appUrl;

  document.body.appendChild(iframe);

  setTimeout(() => {
    document.body.removeChild(iframe);
    clearTimeout(timeout);
  }, 2000);
};

  useEffect(() => {
    if (isCopied) {
      setTimeout(() => {
        setIsCopied(false);
      }, 3000);
    }
  }, [isCopied]);

  return (
    <div className={classNames.join(" ")} style={style}>
      <div className={classes.overlay} onClick={onClose}></div>

      <div className={classes.contents}>
        <button className={classes.closeButton} onClick={onClose}>
          <CloseIcon color="black" size="20px" />
        </button>

        <p className={classes.text}>Share this link via</p>

        <div className={classes.row}>
          <button
            type="button"
            className={classes.messengerButton}
            onClick={() => openShareLink(messengerUrl)}
            aria-label="Share on Messenger"
            title="Share on Messenger"
          >
            <FacebookMessengerIcon round={true} size={42} />
          </button>

          <FacebookShareButton
            url={shareUrl}
            // quote={description}
            hashtag={hashtag?.join(",")}
          >
            <FacebookIcon round={true} size={42} />
          </FacebookShareButton>

          <TwitterShareButton
            url={shareUrl}
            title={description}
            hashtags={hashtag}
          >
            <TwitterIcon round={true} size={42} />
          </TwitterShareButton>

          <LinkedinShareButton url={shareUrl} summary={description}>
            <LinkedinIcon round={true} size={42} />
          </LinkedinShareButton>

          <WhatsappShareButton url={shareUrl} title={description}>
            <WhatsappIcon round={true} size={42} />
          </WhatsappShareButton>

          <button
            type="button"
            className={classes.instagramButton}
            onClick={shareViaInstagram}
            aria-label="Open Instagram profile"
            title="Open Instagram profile"
          >
            <InstagramFillIcon width="22" height="22" />
          </button>

          <PinterestShareButton
            url={shareUrl}
            description={description}
            media={image || ""}
          >
            <PinterestIcon round={true} size={42} />
          </PinterestShareButton>
        </div>

        <p className={classes.text2}>Or copy link</p>

        <div className={classes.copy}>
          <input type="text" value={shareUrl} readOnly={true} />
          <button
            type="button"
            disabled={isCopied}
            onClick={() => {
              navigator.clipboard.writeText(shareUrl);
              setIsCopied(true);
            }}
          >
            {isCopied ? "Copied" : "Copy"}
          </button>
        </div>
      </div>
    </div>
  );
};

export default ShareModal;
